module.exports = __webpack_public_path__ + "static/media/NotB.7bfdf8b7.jpg";